<template>
  <section
    :class="{
      'callouts-with-icon': true,
    }"
  >
    <div :class="{ 'container mx-auto px-0': true }">
      <div>
        <PortableText
          v-if="heading?.standardPortableText && !useInnerBackground"
          :class="{
            'mx-auto mb-10 px-3 text-center text-www-color-neutral-medium-dark': true,
          }"
          :portable-data="heading.standardPortableText"
        />
        <div
          :class="{
            'flex flex-col flex-wrap justify-center md:flex-row': true,
          }"
        >
          <div
            v-for="(callout, index) in callouts"
            :key="index"
            :class="gridColumClass"
          >
            <Callout
              v-if="callout"
              v-bind="callout"
              :use-card-style="useCardStyle"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import Callout from './Callout.vue';
import type { CalloutWithIcon } from '~/sanity/types';
interface Props extends CalloutWithIcon {
  useInnerBackground?: boolean;
  useCardStyle?: boolean;
}
const props = defineProps<Props>();
const columnsPerRow = ref<string>(props.columnsPerRow || '2');
const gridColumClass = computed(() => {
  return {
    [columnsClass[columnsPerRow.value] ?? 'lg:w-1/2']: true,
    'w-full px-3 mb-6': true,
  };
});
const columnsClass: Record<string, string> = {
  '2': 'lg:w-1/2',
  '3': 'lg:w-1/3',
};
</script>

<style lang="scss" scoped></style>
